import { Props } from "../../../propTypes";
import { ObjectLiteral } from "../../../../constants";
import { eGroup, eGroupSectionElement } from "../../../../store/egroups/types";
import _ from "lodash";
import * as React from "react";
import { GroupListItem } from "../GroupListItem";
import { GroupListItemLoading } from "../GroupListItemLoading";
import { SelectedCampus } from "./types";

export interface IAppProps {
    eGroupSectionItem: eGroupSectionElement;
    selectedCampus: SelectedCampus | null;
    sectionTitle: string;
    pageName: string;
}

export interface IAppState {
    loading: boolean;
    eGroups: eGroup[];
    successTimestamp: number;
    selectedCampus: SelectedCampus | null;
}

export default class ListItem extends React.Component<
    IAppProps & Props,
    IAppState
> {
    readonly eGroupsRequestId = Date.now().toString();

    state = {
        loading: true,
        eGroups: [],
        successTimestamp: 0,
        selectedCampus: this.props.selectedCampus,
    };

    componentDidMount() {
        this.fetchContent();
    }

    componentDidUpdate() {
        const eGroupRequestArrayIndex = _.findIndex(
            this.props.eGroups.eGroupRequests,
            { requestId: this.eGroupsRequestId }
        );

        if (
            eGroupRequestArrayIndex > -1 &&
            this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex] &&
            (!_.isEqual(
                this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex]
                    .egroupsList,
                this.state.eGroups
            ) ||
                this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex]
                    .successTimestamp !== this.state.successTimestamp)
        ) {
            this.setState({
                loading: false,
                eGroups:
                    this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex]
                        .egroupsList,
                successTimestamp:
                    this.props.eGroups.eGroupRequests[eGroupRequestArrayIndex]
                        .successTimestamp,
            });
        }

        if (!_.isEqual(this.props.selectedCampus, this.state.selectedCampus)) {
            this.setState({
                selectedCampus: this.props.selectedCampus,
            });

            this.fetchContent();
        }
    }

    fetchContent = () => {
        let params: ObjectLiteral = {};
        let itemsToshow = 1;
        const isMobile = process.browser
            ? window.innerWidth < this.props.main.desktopMinSize
            : false;

        if (this.props.eGroupSectionItem.query) {
            if (
                this.props.eGroupSectionItem &&
                this.props.eGroupSectionItem.query &&
                this.props.eGroupSectionItem.query.content
            ) {
                params = Object.assign(
                    {},
                    this.props.eGroupSectionItem.query.content
                );
            }

            if (
                isMobile &&
                this.props.eGroupSectionItem.layout &&
                this.props.eGroupSectionItem.layout.itemsToShowMobile
            ) {
                itemsToshow =
                    this.props.eGroupSectionItem.layout.itemsToShowMobile;
            } else if (
                !isMobile &&
                this.props.eGroupSectionItem.layout &&
                this.props.eGroupSectionItem.layout.itemsToShowDesktop
            ) {
                itemsToshow =
                    this.props.eGroupSectionItem.layout.itemsToShowDesktop;
            }

            const extraParams = [];
            if (this.props.selectedCampus && this.props.selectedCampus.id) {
                extraParams.push({
                    campusId: this.props.selectedCampus.id,
                });
            }

            if (this.props.eGroups.eGroupHomeData?.requiredQuery) {
                extraParams.push(
                    this.props.eGroups.eGroupHomeData?.requiredQuery
                );
            }

            if (extraParams.length > 0) {
                params["where"] = {
                    ...params["where"],
                    and: [
                        ...(params["where"] && params["where"]["and"]
                            ? params["where"]["and"]
                            : []),
                        ...extraParams,
                    ],
                };
            }

            params["limit"] = itemsToshow;

            const querystring = JSON.stringify(params);

            switch (this.props.eGroupSectionItem.query.type) {
                case "egroup":
                    this.props.actions.eGroups.egroupsGetEgroups({
                        querystring: `filter=${querystring}`,
                        requestId: this.eGroupsRequestId,
                        loadFilters: false,
                    });
                    break;
            }
        }
    };

    renderLoading = () => {
        let itemsToshow = 1;
        const isMobile = process.browser
            ? window.innerWidth < this.props.main.desktopMinSize
            : false;

        if (
            isMobile &&
            this.props.eGroupSectionItem.layout &&
            this.props.eGroupSectionItem.layout.itemsToShowMobile
        ) {
            itemsToshow = this.props.eGroupSectionItem.layout.itemsToShowMobile;
        } else if (
            !isMobile &&
            this.props.eGroupSectionItem.layout &&
            this.props.eGroupSectionItem.layout.itemsToShowDesktop
        ) {
            itemsToshow =
                this.props.eGroupSectionItem.layout.itemsToShowDesktop;
        }

        const content: JSX.Element[] = [];

        for (let i = 0; i < itemsToshow; i++) {
            content.push(<GroupListItemLoading key={i} />);
        }

        return <div className="group-list">{content}</div>;
    };

    public render() {
        if (this.state.loading) {
            return this.renderLoading();
        }

        const finalSectionTitle = this.props.sectionTitle
            ? this.props.sectionTitle.replace(/ /g, "-")
            : "";

        if (this.state.eGroups && this.state.eGroups.length > 0) {
            const idPrefix = `cc-egroups${
                this.props.pageName
                    ? `-${this.props.pageName.toLowerCase()}`
                    : ""
            }${
                this.props.selectedCampus
                    ? `-${this.props.selectedCampus.name}`
                    : ""
            }${
                finalSectionTitle
                    ? `-find-${finalSectionTitle.toLowerCase()}`
                    : ""
            }`;

            return (
                <div className="group-list mob-p-l-spacer-md mob-max-vw-95">
                    {this.state.eGroups.map((egroup: eGroup, key: number) => {
                        return (
                            <GroupListItem
                                key={key}
                                groupListItem={egroup}
                                idPrefix={idPrefix}
                            />
                        );
                    })}
                </div>
            );
        }

        return null;
    }
}
